"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useConversationChannels = exports.CONVERSATION_CHANNELS_QUERY = void 0;
var client_1 = require("@apollo/client");
var graphql_1 = require("../utils/graphql");
var use_active_person_1 = require("./use-active-person");
var lodash_1 = require("lodash");
exports.CONVERSATION_CHANNELS_QUERY = (0, graphql_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query ConversationChannelsQuery($id: ID!) {\n    person(id: $id) {\n      conversationChannels {\n        id\n        channelRole\n        entity { ...EntityValueFields }\n      }\n    }\n  }\n"], ["\n  query ConversationChannelsQuery($id: ID!) {\n    person(id: $id) {\n      conversationChannels {\n        id\n        channelRole\n        entity { ...EntityValueFields }\n      }\n    }\n  }\n"])));
var useConversationChannels = function () {
  var person = (0, use_active_person_1.useActivePerson)().person;
  var data = (0, client_1.useQuery)(exports.CONVERSATION_CHANNELS_QUERY, {
    variables: {
      id: person.id
    }
  }).data;
  var conversationChannels = (0, lodash_1.get)(data, 'person.conversationChannels', []);
  return {
    conversationChannels: conversationChannels
  };
  // return (
  //   useAppData<UseConversationChannelsResult>({ 
  //     query: CONVERSATION_CHANNELS_QUERY,
  //     queryValueKey: 'person.conversationChannels',
  //     valueKey: 'conversationChannels',
  //     stateKey: 'conversationChannels',
  //     defaultValue: [],
  //     variables: { id: person.id }
  //   })
  // );
};
exports.useConversationChannels = useConversationChannels;
var templateObject_1;